import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class GetAffiliateLiquidationsListPaginatedCommand extends IRequestCommand<
  IGetAffiliateLiquidationsListPaginatedResponse,
  ErrorDetails,
  IGetAffiliateLiquidationsListPaginatedCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'affiCheckingAccount/{checkingAccountId}/liquidations/paginated?';

  public override setParameters(
    parameters: IGetAffiliateLiquidationsListPaginatedCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{checkingAccountId}',
      parameters.checkingAccountId.toString()
    );

    this._commandUrl += `page=${parameters.page ?? 1}`;
    this._commandUrl += `&size=${parameters.size ?? 20}`;
    this._commandUrl += `&column=${parameters.column ?? 'idForCarrier'}`;
    this._commandUrl += `&sort=${parameters.sort ?? 'ASC'}`;
    this._commandUrl += `&find=${parameters.find ?? ''}`;

    if (parameters.dateFrom) {
      this._commandUrl += `&dateFrom=${parameters.dateFrom}`;
    }
    if (parameters.dateTo) {
      this._commandUrl += `&dateTo=${parameters.dateTo}`;
    }
    if (parameters.typeview) {
      this._commandUrl += `&typeview=${parameters.typeview}`;
    }
    if (parameters.affiliateId !== undefined && parameters.affiliateId !== null) {
      this._commandUrl += `&affiliateId=${parameters.affiliateId}`;
    }
  }
}

export interface IGetAffiliateLiquidationsListPaginatedCommandParameters {
  checkingAccountId: number;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  find?: string;
  dateFrom?: string;
  dateTo?: string;
  typeview?: string;
  affiliateId?: number;
}

export interface AffiCCLiquidationDTO {
  id: number;
  isLast: boolean;
  creationDate: string;
  processToDate: string;
  status: number;
  total: number;
  observation: string;
  idForCarrier: number;
  paymentMethod: string;
  userId: number;
  currencyCode: string;
  magiisCodeOtherAffi: string;
  carrierNameOtherAffi: string;
}

export interface AffiLiquidationsPageResponse {
  content: AffiCCLiquidationDTO[];
  totalElements: number;
  totalPages: number;
  pageable: {
    pageNumber: number;
    pageSize: number;
  };
  first: boolean;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;
}

export interface IGetAffiliateLiquidationsListPaginatedResponse
  extends ICommandResponse {}
